import { modes, state } from "../state.js";
import { printLine } from "../utilities.js";

export const run = async (args) => {
    if (state.loadedProgram !== null) {
        if (state.loadedProgram.name === "BASIC") {
            state.mode = modes.BASIC;
        }
        state.ready = false;
        state.blockCursor = true;
        await state.loadedProgram.run(args);
        state.ready = true;
        state.blockCursor = false;    
    }

    await printLine();
};